import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import VueScrollTo from "vue-scrollto";
import Home from "@/views/Home.vue";
import showAlert from "@/services/common/showAlert";

Vue.use(VueScrollTo);
Vue.use(Router);

function redirectWithAlert(next) {
  if (typeof next == "function") next(store.state.route.path);

  setTimeout(() => {
    showAlert(
      "Просмотр этой страницы доступен только для авторизованных пользователей.",
      0,
      true,
      "Авторизоваться",
      "center",
      () => store.dispatch("auth/login")
    );
  }, 300);
}

function ifAuthenticated(to, from, next) {
  if (store.getters["auth/isAuthenticated"]) {
    next();
    return;
  }

  const needAuth = to.matched.some(record => record.meta.requiresAuth);

  if (store.getters["auth/authStatus"] === "loading") {
    const unwatch = store.watch(
      () => store.getters["auth/authStatus"],
      () => {
        if (!store.getters["auth/isAuthenticated"] && needAuth) {
          redirectWithAlert(next);
        } else {
          next();
        }
        unwatch();
      }
    );
  } else {
    if (needAuth) {
      redirectWithAlert(next);
    } else {
      next();
    }
  }
}

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
      Vue.$gtag.pageview({ page_path: `${to.path}${to.hash}` });
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    if (!scrollTo) return {};
    VueScrollTo.scrollTo(scrollTo, 500, {
      offset: -100
    });
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    // {
    //   path: "/competition",
    //   name: "competition",
    //   component: () =>
    //     import(/* webpackChunkName: "competition" */ "@/views/Commentators.vue")
    // },
    {
      path: "/prizes",
      name: "prizes",
      component: () =>
        import(/* webpackChunkName: "prizes" */ "@/views/Prizes2021.js")
    },
    // {
    //   path: "/prizes-roll",
    //   name: "roll",
    //   component: () =>
    //     import(/* webpackChunkName: "roll" */ "@/views/PrizesRoll.vue")
    // },
    {
      path: "/how-to-play",
      name: "how-to-play",
      component: () =>
        import(/* webpackChunkName: "manual" */ "@/views/tournament/Manual.vue")
    },
    {
      path: "/winners-2019",
      name: "winners2019",
      component: () =>
        import(
          /* webpackChunkName: "winners" */ "@/views/winners/Winners2019.vue"
        )
    },
    {
      path: "/winners-2021",
      name: "winners2021",
      component: () =>
        import(
          /* webpackChunkName: "winners" */ "@/views/winners/Winners2021.vue"
        )
    },
    {
      path: "/tournament/:tournament_id",

      component: () =>
        import(/* webpackChunkName: "tournament" */ "@/views/Tournament.vue"),
      children: [
        { path: "", redirect: { name: "tournament-info" } },
        {
          path: "info",
          name: "tournament-info",
          component: () =>
            import(
              /* webpackChunkName: "tournament" */ "@/views/tournament/Info.vue"
            )
        },
        {
          path: "bracket",
          name: "tournament-bracket",
          component: () =>
            import(
              /* webpackChunkName: "tournament" */ "@/views/tournament/Bracket.vue"
            )
        },
        {
          path: "matches",
          name: "tournament-matches",
          component: () =>
            import(
              /* webpackChunkName: "tournament" */ "@/views/tournament/Matches.vue"
            )
        },
        {
          path: "match/:match_id",
          name: "tournament-match",
          meta: {
            // requiresAuth: true
          },
          component: () =>
            import(
              /* webpackChunkName: "tournament" */ "@/views/tournament/Match.vue"
            )
        },
        {
          path: "members",
          name: "tournament-members",
          component: () =>
            import(
              /* webpackChunkName: "tournament" */ "@/views/tournament/Members.vue"
            )
        },
        {
          path: "rules",
          name: "tournament-rules",
          component: () =>
            import(
              /* webpackChunkName: "tournament" */ "@/views/tournament/Rules.vue"
            )
        },
        { path: "*", redirect: { name: "tournament-info" } }
      ]
    },
    {
      path: "/password-reset",
      name: "password-reset",
      component: () =>
        import(/* webpackChunkName: "password-reset" */ "@/views/PasswordReset")
    },
    {
      path: "/404",
      name: "404",
      component: () => import(/* webpackChunkName: "404" */ "@/views/404.vue")
    },
    {
      path: "*",
      redirect: "404"
    }
  ]
});

router.beforeEach(ifAuthenticated);

export default router;
